export const InvoiceField = {
  InvoiceSerial: "invoiceSerial",
  InvoiceDate: "invoiceDate",
  invoiceNumber: "invoiceNumber",
  CurrencyId: "currencyId",
  CurrencyCode: "currencyCode",
  exchangeRate: "exchangeRate",
  BuyerTaxCode: "buyerTaxCode",
  BuyerId: "buyerId",
  BuyerCode: "buyerCode",
  BuyerLegalName: "buyerLegalName",
  BuyerAddress: "buyerAddress",
  buyerEmail: "buyerEmail",
  buyerBankAccount: "buyerBankAccount",
  buyerBankName: "buyerBankName",
  buyerDisplayName: "buyerDisplayName",
  buyerTel: "buyerTel",
  OrdinalNumber: "ordinalNumber",
  orders: "orders",
  ProductId: "productId",
  ProductName: "productName",
  ProductCode: "productCode",
  quantity: "quantity",
  UnitPrice: "unitPrice",
  VATRate: "vATRate",
  vATCode: "vatCode",
  vATId: "vATId",
  UnitCode: "unitCode",
  sellerTaxCode: "sellerTaxCode",
  sellerLegalName: "sellerLegalName",
  sellerAddress: "sellerAddress",
  sellerEmail: "sellerEmail",
  sellerTel: "sellerTel",
  sellBankAccount: "sellBankAccount",
  sellerBankName: "sellerBankName",
  sellerFax: "sellerFax",
  sellerWebsite: "sellerWebsite",
  property: "property",
  totalAmount: "totalAmount",
  totalAmountToWord: "totalAmountToWord",
  paymentMethod: "paymentMethod",
  unitCode: "unitCode",
  relatedTemplateCode: "relatedTemplateCode",
  relatedInvoiceSerial: "relatedInvoiceSerial",
  relatedInvoiceDate: "relatedInvoiceDate",
  relatedInvoiceNumber: "relatedInvoiceNumber",
  relatedInvoiceProperty: "relatedInvoiceProperty",
  relatedInvoiceType: "relatedInvoiceType",
  relatedInvoiceId: "relatedInvoiceId",
  templateCode: "templateCode",
  nonTaxZone: "nonTaxZone",
  isDeductionNQ43: "isDeductionNQ43",
  vatRateOverRevenue: "vatRateOverRevenue",
  totalVATDeduction: "totalVATDeduction",
  isHiddenReport: "isHiddenReport",
  invoiceListId: "invoiceListId",
  invoiceListNumber: "invoiceListNumber",
  invoiceListDate: "invoiceListDate",
  relatedInvoiceIds: "relatedInvoiceIds",
  buyerIdentityCard: "buyerIdentityCard",
  buyerBudgetUnitCode: "buyerBudgetUnitCode",
  businessLocationAddress: "businessLocationAddress",
  businessLocationCode: "businessLocationCode",
  businessLocationName: "businessLocationName",
};
